const $ = jQuery.noConflict();
import Global from '../../js/shared/global';
/* eslint-disable */
'use strict';

const Cart = {

	$saveForLaterButton: null,
	$savedForLaterWrapper: null,

	init: function() {
		if (!location.pathname.includes('/cart/')) {
			return;
		}
		this.initDom();
		this.saveForLater();
		this.addToCartFromSaveToLater();
		this.removeFromLater();

		jQuery(document).on('added_to_cart', function() {
			Global.rerenderCart();
		});

		jQuery(document).on('adding_to_cart', function() {
			Global.ajaxLoaderShow();
		});
		$(document).ready(function($) {
			$('.woocommerce-cart-form__cart-item').each(function() {
				const $productNameLink = $(this).find('.product-name a');

				if ($productNameLink.length) {
					const productName = $productNameLink.text().trim().toLowerCase();

					if (productName.includes('gift card')) {
						$(this).addClass('gift-card-item');
					}
				}
			});
		});
	},

	initDom: function() {
		Cart.$saveForLaterButton = $('.product-save-for-later');
		Cart.$savedForLaterWrapper = $('.js-save-for-later-wrapper');
	},

	addToCartFromSaveToLater: function() {
		$(document).on('click', '.js-add-to-cart-from-sfl', function(e) {
			const ele = e.currentTarget;
			const variationColor = ele.getAttribute('data-color');
			const variationSize = ele.getAttribute('data-size');
			const variationPrice = ele.getAttribute('data-customPrice');
			const variationFrame = ele.getAttribute('data-customFrame');
			const variationDeliveryMethod = ele.getAttribute('data-deliveryMethod');
			const id = ele.getAttribute('data-id');
			const itemKey = ele.getAttribute('data-item-key');
			const data = {
				action: 'add-to-cart-from-sfl',
				id,
				itemKey,
				variationColor,
				variationSize,
				variationPrice,
				variationFrame,
				variationDeliveryMethod
			};
			Global.ajaxLoaderShow();
			Cart.ajaxAddToCartSFL(data);
		});
	},

	removeFromLater: function() {
		$(document).on('click', '.js-product-remove-sfl', function(e) {
			const ele = e.currentTarget;
			const id = ele.getAttribute('data-id');
			const itemKey = ele.getAttribute('data-item-key');
			const data = {
				action: 'remove-from-later',
				id,
				itemKey
			};
			Global.ajaxLoaderShow();
			Cart.ajaxRemoveFromSFL(data);
		});
	},

	saveForLater: function() {
		$(document).on('click', '.product-save-for-later', function(e) {
			const $itemSelector = $(e.target).closest('.js-cart-item');
			const variationSize = $itemSelector.find('dd.variation-Size').children('p').text();
			const variationDeliveryMethod = $itemSelector.find('dd.variation-DeliveryMethod').children('p').text();
			const variationColor = $itemSelector.find('dd.variation-Color').children('p').text();
			const variationColorHex = $itemSelector.find('dd.variation-Color p span').attr('data-hex');
			const customPrice = $itemSelector.find('.product-subtotal .woocommerce-Price-amount').text().replace(/[^\d.-]/g, '');
			// Get the src or data-src attribute of the visible image
			const customFrame = $('.product-thumbnail img').attr('src');
			console.log(customPrice);
			const body = {
				'action': 'add-to-later',
				'item-key': $(e.target).data('item-key'),
				'productId': $(e.target).data('product-id'),
				'size': variationSize,
				'color': variationColor,
				'variationColorHex': variationColorHex,
				'customPrice': customPrice,
				'customFrame': customFrame,
				'deliveryMethod': variationDeliveryMethod
			}
			Global.ajaxLoaderShow();
			Cart.sendRequest(body, 'POST');
		});
	},


	ajaxAddToCartSFL: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data,
			success: function(response) {
				Global.rerenderCart();
			}
		});
	},

	ajaxRemoveFromSFL: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data,
			success: function(response) {
				Global.rerenderCart();
			}
		});
	},


	sendRequest: function(body, method) {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: method,
			dataType: 'JSON',
			data: body,
			success: (response) => {
				if (response.success) {
					// Cart.handleSavedProducts(response.data, true)
					Global.rerenderCart();
				} else {
					alert(response.data);
					Global.ajaxLoaderHide();
				}
			},
			complete: () => {
			}
		});
	},


	renderSavedProducts: function(data) {
		const html = `
	<div class="woocommerce-cart-form__cart-item">
	<div class="woocommerce-cart-form__cart-item-left">
		<div class="woocommerce-cart-form__cart-item-left-left">
			<div class="product-thumbnail">
				<a href="javascript:;">
					<img src="https://preserve-my-puzzle.lndo.site/wp-content/themes/fws-preserve-my-puzzle/src/assets/images/order-image-1.png" alt="Product Image">
				</a>
			</div>
			<div class="product-name" data-title="Product">
				<a href="https://preserve-my-puzzle.lndo.site/product/puzzle/?attribute_pa_sizes=large">Preserve your puzzle - Large</a>
				<dl class="variation">
					<dt class="variation-Size">Size:</dt>
					<dd class="variation-Size"><p>large</p></dd>
					<dt class="variation-Color">Frame color:</dt>
					<dd class="variation-Color"><p>white</p></dd>
				</dl>
			</div>
		</div>
		<div class="woocommerce-cart-form__cart-item-left-right">
		<div class="product-remove js-product-remove">
			<a class="remove">Remove</a>
		</div>
			<a class="btn btn--small cart-later__btn" href="javascript:;">Add to cart</a>
		</div>
	</div>
	<div class="woocommerce-cart-form__cart-item-right">
		<div class="product-subtotal" data-title="Subtotal">
			<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>50.00</bdi></span>\t\t\t\t</div>
		</div>
	</div>
		`;
	}
}

export default Cart;
